import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import ListAndPaginate from '../../components/institutePaginate';
import Header from '../../components/instituteHeader';
import BottomFooter from '../../components/instituteFooter';
import Nav from '../../components/instituteNav';
import Search from './search';
import SiderBar from './siderBar';
import SiderBarArticle from './siderBarArticle';
import ActivityPrediction from './activityPrediction';
import { getWyList } from '../../services/api';
import { getImage } from '../../utils/cutImg';

class Layout extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };
    constructor(props) {
        super(props);

        this.state = {
            wyListInfo: {},
            letterList: [],
        };
    }

    componentDidMount() {
        // 上报首屏时间
        if (window && window.BJ_REPORT) window.BJ_REPORT.firstScreen();
        // this.searchWy();
    }

    searchWy = async text => {
        const wyData = await getWyList(text);
        const formatData = [];
        const authList = [];
        const navList = [];

        let charList = [];

        wyData.msg =
            wyData.msg.length > 0
                ? wyData.msg.map(item => {
                      item.feng_url = `//feng.ifeng.com/author/${item.zmt_id}`;

                      item.firstC = this.getUpperAleph(item.spell);
                      item.image = getImage(item.image, 68, 68);
                      formatData.push(item);
                      charList.push(item.firstC);

                      return '';
                  })
                : [];

        charList = Array.from(new Set(charList));
        charList = charList.sort();

        const allForData = this.handlerData(charList, formatData);

        console.log('all===', allForData);
        this.setState({
            wyListInfo: allForData,
            letterList: charList,
        });
        // console.log('ddd==', allForData);
        // console.log('eee===', allForData[charList[0]]);
        // charList.map((item, index) => {
        //     if (index === 0) {
        //         this.setState({
        //             wyListInfo: allForData[item],
        //             letterList: charList,
        //         });
        //     }
        // console.log('item==', item);
        // console.info(allForData[item]);
    };
    // 按照首字母做分组处理
    handlerData = (chaList, dataList) => {
        let dataCh = [];
        let wyDataF = {};

        chaList.map(item => {
            // const letter = item;
            dataCh = dataList.filter(dataItem => {
                return dataItem.firstC === item;
            });

            // wyDataF.set(item, dataCh);
            wyDataF[item] = dataCh;

            return '';
        });

        return wyDataF;
    };

    getUpperAleph = name => {
        // 获取字符串的首字母并将其大写
        let fN = name.charAt(0);

        fN = fN.toUpperCase();

        return fN;
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const {
            header,
            footer,
            navigation,
            columnData,
            newsstream,
            columnId,
            activityPic,
            activityList,
            activityPrediction,
        } = content;
        const { wyListInfo, letterList } = this.state;
        const articleInfo = {
            pic: activityPic,
            list: activityList,
        };

        // navinfo.person = wyListInfo;
        // navinfo.letter = letterList;
        const rightContent = columnId === '1-75-52-' ? <SiderBar /> : <SiderBarArticle content={articleInfo} />;
        const headerContent =
            columnId === '1-75-95376-' ? <ActivityPrediction content={activityPrediction} /> : <div />;
        const navInfo =
            columnId === '1-75-52-' ? (
                <Nav content={navigation} current={3} />
            ) : (
                <Nav content={navigation} current={4} />
            );

        return (
            <div>
                <Header content={header} />
                {navInfo}
                {headerContent}
                <div className={`${styles.w1180} clearfix`}>
                    <div className={styles.mainBlock}>
                        <div className={`${styles.h2wrapper} clearfix`}>
                            <h2>{columnData.title}</h2>
                        </div>
                        <ListAndPaginate content={newsstream} />
                    </div>
                    {rightContent}
                </div>
                <BottomFooter content={footer} />
                <ChipEdit />
            </div>
        );
    }
}

export default Layout;
